import React, { ReactNode } from "react";

import { IgDivider } from "@intelligems/ig-theme";
import { hexToRgbA } from "@intelligems/ig-utils";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";

interface StyledAccordionProps {
  title?: ReactNode;
  content: ReactNode | null;
  defaultExpanded: boolean;
  color: string;
}

export const StyledAccordion = ({
  title,
  content,
  color,
  defaultExpanded,
}: StyledAccordionProps) => {
  return (
    <Grid item sx={{ width: "100%" }}>
      <Accordion
        expanded={content === null ? false : undefined}
        defaultExpanded={defaultExpanded}
        disableGutters={true}
        sx={{
          "&.MuiAccordion-root": {
            borderRadius: "5px",
          },
          "& .MuiDivider-root": {
            marginTop: "0px !important",
          },
          border: `1px solid ${hexToRgbA(color, 0.4)}`,
          boxShadow: "none",
        }}
      >
        <AccordionSummary>{title}</AccordionSummary>
        <IgDivider spacing={"s"} />
        <AccordionDetails>{content}</AccordionDetails>
      </Accordion>
    </Grid>
  );
};
